import alert, { epics as listEpics } from './list';

export const epics = [...listEpics];

export default alert;
